/* global ga */

/**
 * GA モジュール
 * - メールリンクのクリックイベントを Google アナリティクスに送信
 */
export const GA = {
  init() {
    const gnavLinks = document.querySelectorAll('.js-ga-gnav--mail a')
    const footerLinks = document.querySelectorAll('.js-ga-footer--mail a')

    gnavLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (typeof ga === 'function') {
          ga('send', 'event', 'click', 'cv_mail', 'gnav')
        }
      })
    })

    footerLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (typeof ga === 'function') {
          ga('send', 'event', 'click', 'cv_mail', 'footer')
        }
      })
    })
  },
}
